import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { SubmissionError, getFormValues, getFormInitialValues, change } from 'redux-form';
import qs from 'qs';

import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import values from  'lodash/values';
import get from 'lodash/get';
import forEach from 'lodash/forEach';

import http from '../shared/http';
import intl from '../shared/intl';
import checkIsExcludedCountryCode from '../shared/checkIsExcludedCountryCode';

import {
	createSelectOptionsFromSysEnums
} from '../shared/form-elements/select';
import checkPermissions from '../shared/check-permissions';

// actions types
const FETCH_DATA_SUCCESS = 'approve-reject/fetch-data-success';
const FETCH_DATA_ERROR = 'approve-reject/fetch-data-error';

const SUBMIT_SUCCESS = 'approve-reject/submit-success';
const SUBMIT_ERROR = 'approve-reject/submit-error';

const UPDATE_INITIAL_FORM_DATA = 'approve-reject/update-initial-form-data';

const REMOVE_SUCCESS = 'approve-reject/remove-success';
const REMOVE_ERROR = 'approve-reject/remove-error';

const SORT_BY_COLUMN = 'approve-reject/table-sort-by-column';
const SHOW_MORE_ROWS = 'approve-reject/table-show-more-rows';

const TOGGLE_PROGRESS_BAR = 'approve-reject/toggle-progress-bar';

const FETCH_OFFERS_SUCCESS = 'approve-reject/fetch-offers-success';
const FETCH_OFFERS_ERROR = 'approve-reject/fetch-offers-error';

const FETCH_GEOS_SUCCESS = 'approve-reject/fetch-offers-success';
const FETCH_GEOS_ERROR = 'approve-reject/fetch-offers-error';

const FETCH_AFFILIATES_SUCCESS = 'approve-reject/fetch-affiliates-success';
const FETCH_AFFILIATES_ERROR = 'approve-reject/fetch-affiliates-error';

// permissions
export const allowedPermissions = {
	'approvedRejectPayoutsList': 'approved_rejected_payouts_view',
	'approvedRejectPayoutsEdit': 'approved_rejected_payouts_update'
};

// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	table: {
		columns: {
			affiliate: {
				index: 'affiliate',
				title: 'Affiliate',
				direction: 'asc'
			},
			offer: {
				index: 'offer',
				title: 'Offer',
				direction: 'asc'
			},
			geo: {
				index: 'geo',
				title: 'geo',
				direction: 'asc'
			},
			amount_usd: {
				index: 'amount_usd',
				title: 'Amount usd'
			},
			amount_eur: {
				index: 'amount_eur',
				title: 'Amount eur'
			},
			actions: {
				title: 'Actions'
			}
		},
		sortByColumn: {
			index: 'offer',
			title: 'Offer',
			direction: 'asc'
		},
		rowsNumber: 1000
	},
	form: {
		offer_id: null,
		affiliate_id: null,
		geo_id: null,
		usd_payout: null,
		rub_payout: null
	},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: (props) => (dispatch, getState) => {
			(http({
				url: 'v2/approved-rejected-payouts',
				method: 'get',
				actions: [
					FETCH_DATA_SUCCESS,
					FETCH_DATA_ERROR
				]
			}))(dispatch);
		},
		updateInitialFormData: row => (dispatch, getState) => {
			const payouts = selectors.getPayoutCurrencies(getState())
				.reduce((acc, currency) => {
					acc[`${currency}_payout`] = row[`${currency}_payout`];
					return acc;
				}, {});

			const initialData = {
				offer_id: [{value: row.offer_id, label: row.offer}],
				affiliate_id: [{value: row.affiliate_id, label: row.affiliate}],
				geo_id: [{value: row.geo_id, label: row.geo}],
				...payouts
			};

			dispatch({
				type: UPDATE_INITIAL_FORM_DATA,
				payload: initialData
			});
		},
		submitForm: (formData) => (dispatch, getState) => {
			const payoutParams = getFormParams(formData);
			const payoutInitialParams = getFormParams(getFormInitialValues('approvedRejectPayoutsForm')(getState()));
			const isWithInitialParams = !Object.values(payoutInitialParams).some(p => !p);
			const submitData = {
				params: isWithInitialParams ? payoutInitialParams : payoutParams,
				data: selectors.getPayoutCurrencies(getState())
					.map(currency => ({ ...payoutParams, amount: formData[`${currency}_payout`] || 0, currency: currency }))
			};
			const request = http({
				url: 'v2/approved-rejected-payouts',
				method: 'post',
				actions: [
					SUBMIT_SUCCESS,
					SUBMIT_ERROR
				],
				data: submitData
			});

			return request(dispatch)
				.then(action => {
					if (action.type === SUBMIT_SUCCESS) {
						dispatch(actions.redirectToModuleIndex());
					} else if (action.payload.response.status === 400) {
						throw new SubmissionError(
							getVadationErrors(action.payload.response.data, submitData)
						);
					}
				});
		},

		remove: row => dispatch => {
			const query = qs.stringify({
				offer_id: row.offer_id,
				affiliate_id: row.affiliate_id,
				geo_id: row.geo_id
			});
			const request = http({
				url: `v2/approved-rejected-payouts?${query}`,
				method: 'delete',
				actions: [
					REMOVE_SUCCESS,
					REMOVE_ERROR
				]
			});

			dispatch(actions.toggleProgressBar());

			request(dispatch);
		},

		redirectToModuleIndex: () => dispatch => {
			// @todo Adhock for redux-form submit functionality.
			setTimeout(() => dispatch(replace('approve-reject/')), 100);
		},

		sortByColumn: columnIndex => ({
			type: SORT_BY_COLUMN,
			payload: columnIndex
		}),

		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		}),

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),

		resetGeoAndAffiliate: () => dispatch => {
			dispatch(change('approvedRejectPayoutsForm', 'geo_id', null));
			dispatch(change('approvedRejectPayoutsForm', 'affiliate_id', null));
		},

		loadOffersLookup: text => dispatch => {
			const request = http({
				url: `v2/lookups/offers?query=${text}`,
				method: 'get',
				actions: [
					FETCH_OFFERS_SUCCESS,
					FETCH_OFFERS_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_OFFERS_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		loadGeosLookup: text => (dispatch, getState) => {
			const offer_id = selectors.getSelectedOffer(getState()) || null;
			const affiliate_id = selectors.getSelectedAffiliate(getState()) || null;
			const query = qs.stringify({query: text, offer_id, affiliate_id });
			const request = http({
				url: `v2/lookups/locations-with-traffic?${query}`,
				method: 'get',
				actions: [
					FETCH_GEOS_SUCCESS,
					FETCH_GEOS_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_GEOS_SUCCESS) {
					const data = action.payload.data
						.filter(entity => !checkIsExcludedCountryCode(entity.country_code));

					return {
						options: createSelectOptionsFromSysEnums(data)
					};
				}
			});
		},

		loadAffiliatesLookup: text => (dispatch, getState) => {
			const offer_id = selectors.getSelectedOffer(getState());
			const geo_id = selectors.getSelectedGeo(getState());

			const query = qs.stringify({
				query: text,
				offer_id,
				geo_id
			});
			const request = http({
				url: `v2/lookups/affiliates?${query}`,
				method: 'get',
				actions: [
					FETCH_AFFILIATES_SUCCESS,
					FETCH_AFFILIATES_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_AFFILIATES_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		}
	}
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			if (
				action.payload.pathname === 'approve-reject/'
			) {
				return initialState;
			}

			return state;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: action.payload.data, showProgressBar: false, error: false };
		},
		[UPDATE_INITIAL_FORM_DATA]: (state, action) => {
			return { ...state, form: action.payload };
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[SORT_BY_COLUMN]: (state, action) => {
			const { sortByColumn, columns }  = state.table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] == columnIndex ?
				sortByColumn.direction === 'desc' ? 'asc' : 'desc' :
				columns[columnIndex].direction;

			return {
				...state,
				table: {
					...state.table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		},
		[SHOW_MORE_ROWS]: state => ({
			...state,
			table: {
				...state.table,
				rowsNumber: state.table.rowsNumber += initialState.table.rowsNumber
			}
		}),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[REMOVE_SUCCESS]: state => ({...state, data: null}),
		[REMOVE_ERROR]: state => ({...state, error: true}),
		[SUBMIT_ERROR]: (state, action) => {
			const { response: {status = null, data = null} } = action.payload;
			if (status === 400 && !!data) return state;
			return { ...state, error: true };
		}
	}
);
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.approveRejectPayouts.data,
	getPayoutCurrencies: state => state.root.lists['payout-currencies'].map(currency => currency.id),
	getSelectedOffer: state => get(getFormValues('approvedRejectPayoutsForm')(state), 'offer_id.0.value'),
	getSelectedGeo: state => get(getFormValues('approvedRejectPayoutsForm')(state), 'geo_id.0.value'),
	getSelectedAffiliate: state => get(getFormValues('approvedRejectPayoutsForm')(state), 'affiliate_id.0.value'),
	getApproveRejectPayoutsForm: state =>state.approveRejectPayouts.form,
	getTable: state => {
		const { table, data } = state.approveRejectPayouts;
		const rows = data ? sortColumns(data, table.sortByColumn) : [];
		return {
			headers: values(table.columns),
			rows: rows,
			sortedColumn: table.sortByColumn,
			rowsNumber: table.rowsNumber,
			totalRows: rows.length
		};
	},
	getIntl: state => intl(state),
	getProgressBar: state => state.approveRejectPayouts.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.approveRejectPayouts.error
};

// functions
const sortColumns = (rows, sortedColumn) => {
	if (!rows) return null;
	return orderBy(rows, row => row[sortedColumn.index], sortedColumn.direction);
};

function getFormParams(formData) {
	return {
		offer_id: get(formData, 'offer_id.0.value', null),
		geo_id: get(formData, 'geo_id.0.value', null),
		affiliate_id: get(formData, 'affiliate_id.0.value', null)
	};
}

function getVadationErrors(responseErrors, submitData) {
	const validationsErrors = {};
	forEach(responseErrors, value => {
		const key = value.dataPath.slice(1);
		if (key.includes('.amount')) {
			validationsErrors[
				`${get(submitData, key.replace('amount', 'currency'))}_payout`
			] = value.message;
		}
		if (key.includes('params.')) {
			validationsErrors[key.replace('params.', '')] = value.message;
		}
	});
	return validationsErrors;
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/approve-reject/index.js